import { Dialog } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";
import { reasonsRefusalLabelIds, reasonsRefusalOptions, translateDispatchOptions } from "../../../../../../../hooks/useDispatch";

interface RefusalReasonDialogProps {
  show: boolean;
  onClose: () => void;
  newRefusal: { reason: string; description: string };
}

const RefusalReasonDialog = (props: RefusalReasonDialogProps) => {
  const intl = useIntl();
  return (
    <Dialog
        show={props.show}
        onClose={props.onClose}
        showCloseButton
        bsSize={Dialog.SIZE_SM}
      >
        <Dialog.Title title={intl.formatMessage({ id: "intl-msg:kanban.form.refusalReasonDialog.title" })} />
        <Dialog.Body>
          <div className="flex flex-col">
            <div className="font-semibold mt-4">{intl.formatMessage({ id: "intl-msg:kanban.form.refusalReasonDialog.reason" })}</div>
            <div>{translateDispatchOptions(intl, reasonsRefusalOptions, reasonsRefusalLabelIds).find(option => option.id === props.newRefusal?.reason)?.label ?? intl.formatMessage({ id: "intl-msg:kanban.form.refusalReasonDialog.other" })}</div>
            <div className="font-semibold mt-4">{intl.formatMessage({ id: "intl-msg:kanban.form.refusalReasonDialog.description" })}</div>
            <div>{props.newRefusal?.description}</div>
          </div>
        </Dialog.Body>
        <Dialog.Footer>
          <div className="flex items-center justify-center my-4">
            <button className="btn btn-primary btn-link" onClick={props.onClose}>{intl.formatMessage({ id: "intl-msg:kanban.form.refusalReasonDialog.back" })}</button>
          </div>
        </Dialog.Footer>
      </Dialog>
  );
};

export default RefusalReasonDialog;